export const ALL_STORES_ENTITIES = {
  id: 'allStores',
  displayName: '全部门店',
};
